import 'gridstrap/svg-symbols/squircle.svg?sprite';
import './bottom-bar.scss';

import { components } from 'gridstrap/lib/gs-components';
import { GSBottomBar } from './bottom-bar';

components.register({
	selector: '.gs-BottomBar',
	controller: GSBottomBar
});
